import type { GameMode } from "@newfungame/contracts";
import { createFakeTransport } from "./fake";
import { createHttpTransport, type ApiTransport } from "./transport";

export type { ApiTransport } from "./transport";
export { createFakeTransport } from "./fake";
export { createHttpTransport } from "./transport";

/** Транспорт по умолчанию: мок при `?mock=1` или `VITE_API_MOCK=1`, иначе HTTP к своему серверу. */
export function defaultTransport(params: URLSearchParams = new URLSearchParams(), mode?: () => GameMode): ApiTransport {
  const mock = params.get("mock") === "1" || import.meta.env.VITE_API_MOCK === "1";
  return mock ? createFakeTransport() : createHttpTransport("", mode);
}
